"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperAppMockWithRegistrationKey__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5060405161022f38038061022f83398101604081905261002f916100d1565b60405163bd1c448b60e01b81526001600160a01b0384169063bd1c448b9061005d90859085906004016101a8565b600060405180830381600087803b15801561007757600080fd5b505af115801561008b573d6000803e3d6000fd5b505050505050506101e2565b634e487b7160e01b600052604160045260246000fd5b60005b838110156100c85781810151838201526020016100b0565b50506000910152565b6000806000606084860312156100e657600080fd5b83516001600160a01b03811681146100fd57600080fd5b6020850151604086015191945092506001600160401b038082111561012157600080fd5b818601915086601f83011261013557600080fd5b81518181111561014757610147610097565b604051601f8201601f19908116603f0116810190838211818310171561016f5761016f610097565b8160405282815289602084870101111561018857600080fd5b6101998360208301602088016100ad565b80955050505050509250925092565b82815260406020820152600082518060408401526101cd8160608501602087016100ad565b601f01601f1916919091016060019392505050565b603f806101f06000396000f3fe6080604052600080fdfea2646970667358221220510f6e4b33298ce4e3e52a008eb0a19d64fda3c963541b4a7830f41fcfab891064736f6c63430008100033";
const isSuperArgs = (xs) => xs.length > 1;
class SuperAppMockWithRegistrationKey__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, configWord, registrationKey, overrides) {
        return super.deploy(host, configWord, registrationKey, overrides || {});
    }
    getDeployTransaction(host, configWord, registrationKey, overrides) {
        return super.getDeployTransaction(host, configWord, registrationKey, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SuperAppMockWithRegistrationKey__factory = SuperAppMockWithRegistrationKey__factory;
SuperAppMockWithRegistrationKey__factory.bytecode = _bytecode;
SuperAppMockWithRegistrationKey__factory.abi = _abi;
//# sourceMappingURL=SuperAppMockWithRegistrationKey__factory.js.map